import type { SummaryContent } from "@/types/endpoints/reports/GetAiReportById";

type UnknownRecord = Record<string, unknown>;

const isRecord = (v: unknown): v is UnknownRecord =>
  typeof v === "object" && v !== null;

/**
 * Извлекает текст из summary (может быть строкой или объектом с content)
 * Используется во всех ReportCard компонентах
 * 
 * @param summary - данные summary из API (строка или объект)
 * @returns извлечённый текст или пустая строка
 */
export function extractSummaryText(summary: SummaryContent | undefined | null): string {
  if (!summary) return "";
  if (typeof summary === "string") return summary;
  if (isRecord(summary) && typeof summary.content === "string") {
    return summary.content;
  }
  return String(summary);
}

/**
 * Получает локализованный summary в зависимости от текущей локали
 * Используется для многоязычных отчетов (evaluation)
 *
 * @param data - объект с полями summary_ru, summary_kz, summary_en
 * @param locale - текущая локаль (ru, kk, en)
 * @returns локализованный summary или null
 */
export function getLocalizedSummary<T extends {
  summary_ru?: SummaryContent;
  summary_kz?: SummaryContent;
  summary_en?: SummaryContent;
}>(data: T, locale: string): SummaryContent | null {
  switch (locale) {
    case "kk":
      return data.summary_kz || data.summary_ru || null;
    case "en":
      return data.summary_en || data.summary_ru || null;
    case "ru":
    default:
      return data.summary_ru || null;
  }
}
